<div class="SLV2-quit-popup">
    <!-- <button class="SLV2-popup-close-btn" (click)="close()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
    </button> -->
    <div class="SLV2-popup-content-area">
        <!-- <img src="selflearnv2-ui/assets/img/self-learn-v2/sad-emoji-animated.gif" class="SLV2-popup-sad-emoji" /> -->
        <h5  class="SLV2-popup-blue-heading">Revisit Questions</h5>
    </div>
    <div class="SLV2-popup-actn-area SLV2-for-checkbox-only" (click)="seeAnswers()">
            <ng-container *ngIf="isCheckboxChecked"><input  type="checkbox"  id="1"  checked=true/></ng-container>
            <ng-container  *ngIf="!isCheckboxChecked"><input  type="checkbox"  /></ng-container>           
        <label class="mat-radio-label">Show previously marked answers</label>
    </div>
    <div class="SLV2-popup-actn-area">
        <button class="SLV2-popup-text-btn" (click)="close()">Cancel</button>
        <button class="SLV2-popup-solid-btn" (click)="navigateToPreviousPage()" >Continue</button>
    </div>
</div>